var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / maps / pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 28.1874L15.2948 27.4934C21.978 21.6577 25.375 16.5623 25.375 12.0833C25.375 5.7403 20.4244 1.20825 14.5 1.20825C8.57561 1.20825 3.625 5.7403 3.625 12.0833C3.625 16.5623 7.022 21.6577 13.7052 27.4934L14.5 28.1874ZM14.5 24.9682C8.82882 19.8571 6.04167 15.5261 6.04167 12.0833C6.04167 7.12498 9.86497 3.62492 14.5 3.62492C19.135 3.62492 22.9583 7.12498 22.9583 12.0833C22.9583 15.5261 20.1712 19.8571 14.5 24.9682ZM14.5 6.04159C17.8367 6.04159 20.5417 8.74653 20.5417 12.0833C20.5417 15.42 17.8367 18.1249 14.5 18.1249C11.1633 18.1249 8.45833 15.42 8.45833 12.0833C8.45833 8.74653 11.1633 6.04159 14.5 6.04159ZM10.875 12.0833C10.875 10.0812 12.498 8.45825 14.5 8.45825C16.502 8.45825 18.125 10.0812 18.125 12.0833C18.125 14.0853 16.502 15.7083 14.5 15.7083C12.498 15.7083 10.875 14.0853 10.875 12.0833Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.6dc43685b54ba2b6f176ad87855d2be1.svg";
export { ForwardRef as ReactComponent };